import {VirtualReceiptItem} from "./virtualReceiptItem";
import {User} from "../../models";

export class VirtualReceipt {
    id: string;
    items: VirtualReceiptItem[];
    createdAt: string;
    updatedAt: string;
    createdBy: User;
    updatedBy: User;
    customer: User;
}
